export const LimitTypes = {
  CONTENT_OBJECT_LIMIT: 'CONTENT_OBJECT_LIMIT',
  CONTENT_GROUP_LIMIT: 'CONTENT_GROUP_LIMIT',
  CONTENT_OBJECT_MULTI_LANG_GROUP_SIZE_LIMIT: 'CONTENT_OBJECT_MULTI_LANG_GROUP_SIZE_LIMIT'
};